/*
 * Copyright (c) 2024. Tooling Team
 */
//todo: integrate this file with US990243 changes once available

import PropTypes from "prop-types";
import { ModalDialog } from "@uhg-abyss/web/ui/ModalDialog";
import { Button } from "@uhg-abyss/web/ui/Button";
import { Layout } from "@uhg-abyss/web/ui/Layout";
import { Grid } from "@uhg-abyss/web/ui/Grid";
import React from "react";
import {
  downloadInvalidRows,
  getFailedRecordCount,
  getFormattedRows,
  getValidationMsg,
  isDownloadDisabled,
} from "./BulkUploadUtils.js";

export default function BulkUploadResultsForm(props) {
  let finalFailedRowData = getFormattedRows(props);

  return (
    <ModalDialog
      isOpen={props.isOpen}
      header={"Bulk Upload Results of file " + props.formData.fileName}
      onClose={props.onClose}
      footer={
        <Layout.Group alignLayout="right">
          <Button onClick={props.onClose}>Ok</Button>
          <Button
            variant="outline"
            color="neutral"
            isDisabled={isDownloadDisabled(props)}
            onClick={() => downloadInvalidRows(props, finalFailedRowData)}
          >
            Download Invalid Rows
          </Button>
        </Layout.Group>
      }
    >
      <Grid>
        <Grid.Col className="px-4">
          {getValidationMsg(props, "uploaded")}
          <br />
          Total number of uploaded records: {}
          {props.formData.succeededRows.length}
          <br />
          Total number of failed records: {}
          {getFailedRecordCount(props, finalFailedRowData)}
        </Grid.Col>
      </Grid>
    </ModalDialog>
  );
}

BulkUploadResultsForm.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  bulkUploadPreviewCallback: PropTypes.func,
  formData: PropTypes.object,
  formCallback: PropTypes.func,
  activeDomain: PropTypes.object,
};
